import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const Slide = ({ image, width, opacity }) => (
  <div className="slide-container" style={{ width: `${width}%`, opacity }}>
    <div
      className="slide"
      style={{
        backgroundImage: `url(${image})`,
        backgroundPosition: 'center',
        backgroundRepeatX: 'no-repeat',
        backgroundRepeatY: 'no-repeat',
      }}
    />
  </div>
);

Slide.propTypes = {
  image: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  opacity: PropTypes.string.isRequired,
};

export default Slide;
